export const NOTIFICATION_DRAWER_OPEN_EVENT = "notification-drawer-open";

export const openNotificationDrawer = () => {
  window.dispatchEvent(new CustomEvent(NOTIFICATION_DRAWER_OPEN_EVENT));
};
